export default __webpack_public_path__ + "static/media/arrow_down_filter.13338ade.svg";